module.exports = __webpack_public_path__ + "img/baokuan.0b50ee95.png";